var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZohoCrm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:4.5;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M26.3655,13.9999c5.1292-2.9937,11.671-1.5275,15.068,3.377,3.3971,4.9046,2.5225,11.62-2.0145,15.469-4.537,3.8486-11.231,3.5531-15.419-.6806l-8.077-8.1653c-1.1152-1.1274-1.1152-2.9552,0-4.0827,1.1152-1.1274,2.9233-1.1274,4.0385,0l8.077,8.1653c1.1152,1.1274,2.9233,1.1274,4.0385,0s1.1152-2.9552,0-4.0827l-8.077-8.1653c-4.188-4.2337-10.882-4.5292-15.419-.6806-4.537,3.8487-5.4116,10.564-2.0145,15.469,3.3971,4.9046,9.9389,6.3707,15.068,3.377"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZohoCrm);
export default __webpack_public_path__ + "static/media/zoho_crm.b630e7ea.svg";
export { ForwardRef as ReactComponent };